<template>
  <div class="px-6 py-6 space-y-6 font-light select-none text-left min-h-screen transition-colors duration-200"
    :class="isDark ? 'bg-zinc-950 text-zinc-400' : 'bg-gray-50 text-gray-700'">

    <div class="flex sm:flex-row justify-between items-start sm:items-center border-b pb-5 gap-4 transition-colors duration-200"
      :class="isDark ? 'border-zinc-900/60' : 'border-gray-200'">
      <div class="space-y-1">
        <h1 class="text-xl font-medium tracking-tight transition-colors duration-200"
          :class="isDark ? 'text-white' : 'text-gray-900'">Terminal d'Encaissement</h1>
        <p class="text-xs font-light transition-colors duration-200"
          :class="isDark ? 'text-zinc-500' : 'text-gray-500'">Émettez les factures, déduisez les garanties d'acomptes et clôturez les transactions de caisse.</p>
      </div>

      <div class="text-right font-mono text-[11px] px-4 py-2 rounded-xl transition-colors duration-200"
        :class="isDark
          ? 'text-zinc-500 bg-zinc-900/40 border border-zinc-900'
          : 'text-gray-600 bg-white border border-gray-200'">
        <span>STATUT : CONSOLE OUVERTE</span>
      </div>
    </div>

    <div class="grid  lg:grid-cols-3 gap-6 items-start w-full">
      
      <div class="lg:col-span-2 space-y-6">
        
        <div class="border rounded-2xl p-5 space-y-4 transition-colors duration-200"
          :class="isDark
            ? 'bg-zinc-900/20 border-zinc-900'
            : 'bg-white border-gray-200 shadow-sm'">
          <h2 class="text-xs font-medium uppercase tracking-widest font-mono border-b pb-2 transition-colors duration-200"
            :class="isDark
              ? 'text-zinc-400 border-zinc-900'
              : 'text-gray-600 border-gray-200'">1. Profil à Facturer</h2>

          <div class="grid sm:grid-cols-2 gap-4 items-center">
            <div class="space-y-1.5">
              <label class="block text-[10px] uppercase tracking-widest font-medium font-mono transition-colors duration-200"
                :class="isDark ? 'text-zinc-500' : 'text-gray-500'">Sélectionner l'affilié</label>
              <select v-model="transaction.clientId"  class="w-full px-4 py-2.5 rounded-xl border focus:outline-none text-xs cursor-pointer appearance-none transition-colors duration-200"
                :class="isDark
                  ? 'border-zinc-900 bg-zinc-900/40 text-zinc-300 focus:border-zinc-700 focus:bg-zinc-900/80'
                  : 'border-gray-300 bg-white text-gray-900 focus:border-gray-400'">
                <option value="">Client de passage (Anonyme)</option>
                <option v-for="c in mockClients" :key="c.id" :value="c.id">{{ c.nom }}</option>
              </select>
            </div>

            <div v-if="appointmentPaymentAmount > 0" class="p-3.5 bg-amber-950/20 border border-amber-900/40 rounded-xl text-amber-500 flex items-center gap-3">
              <i class="fas fa-shield-alt text-sm"></i>
              <div class="text-[11px] leading-snug">
                <p class="font-semibold uppercase tracking-wider text-[10px]">
                  {{ appointmentIsPaidCompletely ? 'Paiement Intégral Détecté' : 'Acompte Détecté' }}
                </p>
                <p class="text-zinc-400 font-light mt-0.5">
                  {{ appointmentIsPaidCompletely ? 'Montant de' : 'Une garantie de' }}
                  <span class="font-mono text-white font-medium">{{ appointmentPaymentAmount.toFixed(2) }} €</span>
                  {{ appointmentIsPaidCompletely ? 'déjà payé en ligne.' : 'a été pré-autorisée en ligne.' }}
                </p>
              </div>
            </div>
          </div>
        </div>

        <div class="border rounded-2xl p-5 space-y-4 transition-colors duration-200"
          :class="isDark
            ? 'bg-zinc-900/20 border-zinc-900'
            : 'bg-white border-gray-200 shadow-sm'">
          <div class="flex justify-between items-center border-b pb-2 transition-colors duration-200"
            :class="isDark ? 'border-zinc-900' : 'border-gray-200'">
            <h2 class="text-xs font-medium uppercase tracking-widest font-mono transition-colors duration-200"
              :class="isDark ? 'text-zinc-400' : 'text-gray-600'">2. Lignes de Facturation</h2>
            <button @click="openItemCatalog" class="text-[11px] font-mono uppercase hover:underline transition-colors duration-200"
              :class="isDark ? 'text-[#D5CCBC]' : 'text-amber-600'">+ Injecter un Acte / Produit</button>
          </div>

          <div class="overflow-x-auto no-scrollbar">
            <table class="w-full text-xs text-left">
              <thead class="border-b text-[10px] uppercase tracking-wider font-mono transition-colors duration-200"
                :class="isDark
                  ? 'text-zinc-600 border-zinc-900/40'
                  : 'text-gray-600 border-gray-200'">
                <tr>
                  <th class="pb-2 font-medium">Libellé de l'élément</th>
                  <th class="pb-2 font-medium w-20 text-center">Qté</th>
                  <th class="pb-2 font-medium text-right w-24">Prix Unitaire</th>
                  <th class="pb-2 font-medium text-right w-24">Total Brut</th>
                  <th class="pb-2 text-right w-12"></th>
                </tr>
              </thead>
              <tbody class="divide-y font-light transition-colors duration-200"
                :class="isDark ? 'divide-zinc-900/40' : 'divide-gray-200'">
                <tr v-for="(item, idx) in transaction.cart" :key="idx" class="transition-colors duration-200"
                  :class="isDark ? 'hover:bg-zinc-900/10' : 'hover:bg-gray-50'">
                  <td class="py-3 pr-2 font-medium transition-colors duration-200"
                    :class="isDark ? 'text-zinc-200' : 'text-gray-900'">
                    <div>{{ item.nom }}</div>
                    <span class="text-[9px] uppercase font-mono tracking-wider transition-colors duration-200"
                      :class="isDark ? 'text-zinc-600' : 'text-gray-500'">{{ item.type }}</span>
                  </td>
                  <td class="py-3 text-center pr-2 font-mono">
                    <input type="number" v-model.number="item.qte" min="1" class="w-12 text-center border rounded py-0.5 focus:outline-none transition-colors duration-200"
                      :class="isDark
                        ? 'bg-zinc-950 border-zinc-900 text-white focus:border-zinc-700'
                        : 'bg-white border-gray-300 text-gray-900 focus:border-gray-400'" />
                  </td>
                  <td class="py-3 text-right pr-2 font-mono transition-colors duration-200"
                    :class="isDark ? 'text-zinc-400' : 'text-gray-600'">{{ item.prix }} €</td>
                  <td class="py-3 text-right pr-2 font-mono font-medium transition-colors duration-200"
                    :class="isDark ? 'text-white' : 'text-gray-900'">{{ item.prix * item.qte }} €</td>
                  <td class="py-3 text-right">
                    <button @click="removeItem(idx)" class="hover:text-red-400 transition-colors"
                      :class="isDark ? 'text-zinc-700' : 'text-gray-400'">
                      <i class="fas fa-times text-[11px]"></i>
                    </button>
                  </td>
                </tr>

                <tr v-if="transaction.cart.length === 0">
                  <td colspan="5" class="text-center py-8 italic transition-colors duration-200"
                    :class="isDark ? 'text-zinc-700' : 'text-gray-400'">Aucun élément dans le panier de facturation.</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div class="border rounded-2xl p-5 space-y-4 transition-colors duration-200"
          :class="isDark
            ? 'bg-zinc-900/20 border-zinc-900'
            : 'bg-white border-gray-200 shadow-sm'">
          <h2 class="text-xs font-medium uppercase tracking-widest font-mono border-b pb-2 transition-colors duration-200"
            :class="isDark
              ? 'text-zinc-400 border-zinc-900'
              : 'text-gray-600 border-gray-200'">3. Ventilation des Règlements</h2>

          <div class="grid grid-cols-2 sm:grid-cols-4 gap-3">
            <button
              v-for="method in paymentMethods"
              :key="method.id"
              @click="method.disabled ? null : setPaymentMethod(method.id)"
              :disabled="method.disabled"
              class="p-3.5 rounded-xl border text-center font-mono text-[11px] uppercase tracking-wider transition-all duration-200 relative"
              :class="[
                transaction.paymentMethod === method.id
                  ? isDark
                    ? 'border-[#D5CCBC] bg-zinc-900 text-white font-semibold'
                    : 'border-amber-600 bg-amber-50 text-amber-900 font-semibold'
                  : isDark
                    ? 'border-zinc-900 bg-zinc-900/30 hover:border-zinc-800 text-zinc-500'
                    : 'border-gray-200 bg-gray-50 hover:border-gray-300 text-gray-600',
                method.disabled ? 'opacity-40 cursor-not-allowed' : 'cursor-pointer'
              ]"
            >
              <i :class="method.icon" class="block text-base mb-1.5 opacity-80"></i>
              {{ method.nom }}
              <span v-if="method.disabled" class="block text-[9px] text-amber-400 mt-1 font-light tracking-normal">
                {{ method.message }}
              </span>
            </button>
          </div>
        </div>

      </div>

      <div class="w-full space-y-6">
        <div class="border rounded-2xl p-5 space-y-6 sticky top-6 transition-colors duration-200"
          :class="isDark
            ? 'bg-zinc-900/30 border-zinc-900 shadow-2xl shadow-black/40'
            : 'bg-white border-gray-200 shadow-lg'">
          <div class="border-b pb-3 transition-colors duration-200"
            :class="isDark ? 'border-zinc-900' : 'border-gray-200'">
            <h2 class="text-xs font-medium uppercase tracking-widest font-mono transition-colors duration-200"
              :class="isDark ? 'text-zinc-500' : 'text-gray-600'">Bordereau Comptable</h2>
          </div>

          <div class="space-y-3.5 text-xs font-light">
            <div class="flex justify-between transition-colors duration-200"
              :class="isDark ? 'text-zinc-500' : 'text-gray-600'">
              <span>Total Brut Prestations & Ventes</span>
              <span class="font-mono transition-colors duration-200"
                :class="isDark ? 'text-zinc-300' : 'text-gray-900'">{{ subtotalPrice }} €</span>
            </div>

            <!-- Promotions -->
            <div class="space-y-3 border-t pt-3 transition-colors duration-200"
              :class="isDark ? 'border-zinc-900' : 'border-gray-200'">
              <div class="flex justify-between items-center">
                <span class="text-[11px] uppercase tracking-wider font-medium transition-colors duration-200"
                  :class="isDark ? 'text-zinc-400' : 'text-gray-600'">Réduction / Promotion</span>
              </div>

              <!-- Sélection d'une promotion existante -->
              <div class="space-y-1.5">
                <label class="block text-[10px] uppercase tracking-widest font-medium font-mono transition-colors duration-200"
                  :class="isDark ? 'text-zinc-500' : 'text-gray-500'">Promotion pré-créée</label>
                <select v-model="transaction.selectedPromoId" @change="applyPromotion" class="w-full px-3 py-2 rounded-lg border focus:outline-none text-xs cursor-pointer transition-colors duration-200"
                  :class="isDark
                    ? 'border-zinc-900 bg-zinc-900/40 text-zinc-300 focus:border-zinc-700'
                    : 'border-gray-300 bg-white text-gray-900 focus:border-gray-400'">
                  <option value="">Aucune promotion</option>
                  <option v-for="promo in availablePromotions" :key="promo.id" :value="promo.id">
                    {{ promo.nom }} - {{ promo.type === 'pourcentage' ? `${promo.valeur}%` : `${promo.valeur}€` }}
                  </option>
                </select>
              </div>

              <!-- OU réduction manuelle -->
              <div class="text-center text-[10px] uppercase tracking-widest font-mono transition-colors duration-200"
                :class="isDark ? 'text-zinc-600' : 'text-gray-400'">— ou —</div>

              <div class="space-y-2">
                <label class="block text-[10px] uppercase tracking-widest font-medium font-mono transition-colors duration-200"
                  :class="isDark ? 'text-zinc-500' : 'text-gray-500'">Réduction ponctuelle</label>

                <div class="flex gap-2 items-center">
                  <!-- Type de réduction -->
                  <div class="flex gap-1 p-1 rounded-lg transition-colors duration-200"
                    :class="isDark ? 'bg-zinc-900/60' : 'bg-gray-100'">
                    <button
                      @click="transaction.discountType = 'pourcentage'"
                      type="button"
                      class="px-3 py-1 rounded text-[10px] font-medium uppercase tracking-wider transition-colors"
                      :class="transaction.discountType === 'pourcentage'
                        ? isDark
                          ? 'bg-[#D5CCBC] text-black'
                          : 'bg-amber-600 text-white'
                        : isDark
                          ? 'text-zinc-500 hover:text-zinc-300'
                          : 'text-gray-600 hover:text-gray-900'"
                    >
                      %
                    </button>
                    <button
                      @click="transaction.discountType = 'fixe'"
                      type="button"
                      class="px-3 py-1 rounded text-[10px] font-medium uppercase tracking-wider transition-colors"
                      :class="transaction.discountType === 'fixe'
                        ? isDark
                          ? 'bg-[#D5CCBC] text-black'
                          : 'bg-amber-600 text-white'
                        : isDark
                          ? 'text-zinc-500 hover:text-zinc-300'
                          : 'text-gray-600 hover:text-gray-900'"
                    >
                      €
                    </button>
                  </div>

                  <!-- Valeur -->
                  <input
                    v-model.number="transaction.discountValue"
                    type="number"
                    min="0"
                    :max="transaction.discountType === 'pourcentage' ? 100 : subtotalPrice"
                    placeholder="0"
                    class="flex-1 px-3 py-1.5 border rounded-lg text-xs font-mono focus:outline-none text-right transition-colors duration-200"
                    :class="isDark
                      ? 'bg-zinc-950 border-zinc-900 text-white focus:border-zinc-700'
                      : 'bg-white border-gray-300 text-gray-900 focus:border-gray-400'"
                  />
                </div>
              </div>

              <!-- Affichage de la réduction appliquée -->
              <div v-if="discountAmount > 0" class="flex justify-between text-emerald-500 bg-emerald-950/10 border border-emerald-900/30 p-2.5 rounded-xl">
                <span class="text-[11px]">Réduction appliquée</span>
                <span class="font-mono font-semibold">- {{ discountAmount.toFixed(2) }} €</span>
              </div>
            </div>

            <div v-if="appointmentPaymentAmount > 0" class="flex justify-between text-amber-500 bg-amber-950/10 border border-amber-900/30 p-2.5 rounded-xl">
              <span>{{ appointmentIsPaidCompletely ? 'Déjà payé en ligne' : 'Déduction Acompte En ligne' }}</span>
              <span class="font-mono font-semibold">- {{ appointmentPaymentAmount.toFixed(2) }} €</span>
            </div>

            <div class="border-t pt-4 space-y-3 font-medium transition-colors duration-200"
              :class="isDark ? 'border-zinc-900' : 'border-gray-200'">
              <div class="flex justify-between items-center text-sm">
                <span class="transition-colors duration-200"
                  :class="isDark ? 'text-white' : 'text-gray-900'">Net À Payer (TTC)</span>
                <span class="font-mono text-xl font-semibold transition-colors duration-200"
                  :class="[
                    appointmentIsPaidCompletely && parseFloat(finalNetPrice) === 0
                      ? 'text-emerald-500'
                      : isDark ? 'text-[#D5CCBC]' : 'text-amber-600'
                  ]">{{ finalNetPrice }} €</span>
              </div>
              <div v-if="appointmentIsPaidCompletely && parseFloat(finalNetPrice) === 0"
                   class="text-[10px] text-center font-medium text-emerald-500 bg-emerald-950/20 border border-emerald-900/30 rounded-lg p-2">
                ✓ Rendez-vous entièrement payé en ligne
              </div>
              <div v-else class="text-[10px] text-right font-mono font-light transition-colors duration-200"
                :class="isDark ? 'text-zinc-600' : 'text-gray-500'">dont TVA calculée (20%) : {{ taxPrice }} €</div>
            </div>
          </div>

          <div class="pt-4 border-t space-y-2 transition-colors duration-200"
            :class="isDark ? 'border-zinc-900' : 'border-gray-200'">
            <button
              @click="executeCheckout"
              :disabled="appointmentIsPaidCompletely && parseFloat(finalNetPrice) === 0"
              class="w-full py-3 rounded-xl text-xs font-semibold uppercase tracking-wider transition-all shadow-xl active:scale-[0.99] disabled:opacity-50 disabled:cursor-not-allowed"
              :class="[
                appointmentIsPaidCompletely && parseFloat(finalNetPrice) === 0
                  ? 'bg-gray-400 text-white'
                  : isDark
                    ? 'bg-white hover:bg-[#D5CCBC] text-black shadow-white/5'
                    : 'bg-amber-600 hover:bg-amber-700 text-white shadow-amber-600/20'
              ]">
              {{ appointmentIsPaidCompletely && parseFloat(finalNetPrice) === 0 ? 'Déjà Payé en Ligne' : 'Encaisser & Clôturer la Session' }}
            </button>
            <button @click="printReceiptOnly" class="w-full py-2.5 rounded-xl text-xs font-medium uppercase tracking-wider border transition-colors"
              :class="isDark
                ? 'bg-zinc-900 hover:bg-zinc-800 text-zinc-400 hover:text-white border-zinc-800/60'
                : 'bg-gray-100 hover:bg-gray-200 text-gray-700 border-gray-300'">
              <i class="fas fa-print text-[10px] mr-1.5"></i> Émettre Ticket Provisoire
            </button>
          </div>
        </div>
      </div>

    </div>

    <!-- Modale QR Code Stripe -->
    <div v-if="showQrCodeModal" class="fixed inset-0 bg-black/80 flex items-center justify-center z-50 backdrop-blur-sm" @click.self="closeQrCodeModal">
      <div class="border rounded-2xl p-8 max-w-md w-full mx-4 space-y-6 transition-colors duration-200"
        :class="isDark
          ? 'bg-zinc-900 border-zinc-800'
          : 'bg-white border-gray-200'">
        <div class="text-center space-y-2">
          <div class="w-12 h-12 bg-purple-950/40 border border-purple-900/40 rounded-full mx-auto flex items-center justify-center">
            <i class="fas fa-qrcode text-purple-400 text-xl"></i>
          </div>
          <h2 class="text-xl font-medium transition-colors duration-200"
            :class="isDark ? 'text-white' : 'text-gray-900'">Paiement sans contact</h2>
          <p class="text-xs transition-colors duration-200"
            :class="isDark ? 'text-zinc-500' : 'text-gray-500'">Scannez le QR Code avec votre téléphone pour payer</p>
        </div>

        <!-- QR Code -->
        <div v-if="qrCodeData" class="bg-white p-6 rounded-xl mx-auto w-fit">
          <img :src="qrCodeData" alt="QR Code" class="w-64 h-64" />
        </div>

        <!-- Loading state -->
        <div v-else class="flex justify-center py-12">
          <div class="animate-spin rounded-full h-12 w-12 border-b-2 border-purple-400"></div>
        </div>

        <div class="space-y-3">
          <div class="border rounded-xl p-4 space-y-2 transition-colors duration-200"
            :class="isDark
              ? 'bg-zinc-950/60 border-zinc-800'
              : 'bg-gray-50 border-gray-200'">
            <div class="flex justify-between text-xs">
              <span class="transition-colors duration-200"
                :class="isDark ? 'text-zinc-500' : 'text-gray-500'">Montant à payer</span>
              <span class="font-mono font-semibold text-base transition-colors duration-200"
                :class="isDark ? 'text-white' : 'text-gray-900'">{{ finalNetPrice }} €</span>
            </div>
            <div class="flex justify-between text-xs">
              <span class="transition-colors duration-200"
                :class="isDark ? 'text-zinc-500' : 'text-gray-500'">Statut</span>
              <span class="text-amber-400 font-medium">
                <i class="fas fa-clock mr-1"></i>
                {{ paymentStatus === 'checking' ? 'Vérification...' : 'En attente de paiement' }}
              </span>
            </div>
          </div>

          <button @click="closeQrCodeModal" class="w-full py-3 rounded-xl text-xs font-medium uppercase tracking-wider transition-colors"
            :class="isDark
              ? 'bg-zinc-800 hover:bg-zinc-700 text-zinc-300'
              : 'bg-gray-200 hover:bg-gray-300 text-gray-700'">
            <i class="fas fa-times mr-2"></i>
            Annuler le paiement
          </button>
        </div>
      </div>
    </div>

    <!-- Modale Sélection de Service -->
    <div v-if="showServiceModal" class="fixed inset-0 bg-black/80 flex items-center justify-center z-50 backdrop-blur-sm p-4" @click.self="closeServiceModal">
      <div class="border rounded-2xl p-6 max-w-2xl w-full max-h-[80vh] overflow-y-auto transition-colors duration-200"
        :class="isDark
          ? 'bg-zinc-900 border-zinc-800'
          : 'bg-white border-gray-200'">

        <!-- Header -->
        <div class="flex justify-between items-center mb-6 pb-4 border-b transition-colors duration-200"
          :class="isDark ? 'border-zinc-800' : 'border-gray-200'">
          <div>
            <h2 class="text-lg font-medium transition-colors duration-200"
              :class="isDark ? 'text-white' : 'text-gray-900'">Catalogue des Services</h2>
            <p class="text-xs mt-1 transition-colors duration-200"
              :class="isDark ? 'text-zinc-500' : 'text-gray-500'">Sélectionnez un service à ajouter au panier</p>
          </div>
          <button @click="closeServiceModal" class="text-zinc-500 hover:text-white transition-colors">
            <i class="fas fa-times text-lg"></i>
          </button>
        </div>

        <!-- Search -->
        <div class="mb-4">
          <input
            v-model="serviceSearchQuery"
            type="text"
            placeholder="Rechercher un service..."
            class="w-full px-4 py-2.5 rounded-xl border focus:outline-none text-sm transition-colors duration-200"
            :class="isDark
              ? 'border-zinc-800 bg-zinc-950 text-white placeholder-zinc-600 focus:border-zinc-700'
              : 'border-gray-300 bg-white text-gray-900 placeholder-gray-400 focus:border-gray-400'" />
        </div>

        <!-- Services List -->
        <div v-if="availableServices.length > 0" class="space-y-2">
          <button
            v-for="service in filteredServices"
            :key="service._id"
            @click="addServiceToCart(service)"
            class="w-full p-4 rounded-xl border text-left transition-all hover:scale-[1.01] active:scale-[0.99]"
            :class="isDark
              ? 'border-zinc-800 bg-zinc-900/40 hover:bg-zinc-900 hover:border-zinc-700'
              : 'border-gray-200 bg-gray-50 hover:bg-white hover:border-gray-300'">
            <div class="flex justify-between items-start">
              <div class="flex-1">
                <h3 class="font-medium text-sm transition-colors duration-200"
                  :class="isDark ? 'text-white' : 'text-gray-900'">{{ service.nom }}</h3>
                <div class="flex gap-2 mt-2">
                  <span v-if="service.duree" class="text-[10px] px-2 py-1 rounded-full transition-colors duration-200"
                    :class="isDark
                      ? 'bg-zinc-800 text-zinc-400'
                      : 'bg-gray-200 text-gray-600'">
                    <i class="fas fa-clock mr-1"></i>{{ service.duree }} min
                  </span>
                  <span v-if="service.categorie" class="text-[10px] px-2 py-1 rounded-full transition-colors duration-200"
                    :class="isDark
                      ? 'bg-zinc-800 text-zinc-400'
                      : 'bg-gray-200 text-gray-600'">
                    {{ service.categorie.nom }}
                  </span>
                </div>
              </div>
              <div class="ml-4 text-right">
                <div class="font-mono font-semibold text-lg transition-colors duration-200"
                  :class="isDark ? 'text-[#D5CCBC]' : 'text-amber-600'">{{ service.prix }} €</div>
                <div class="text-[10px] uppercase tracking-wider mt-1 transition-colors duration-200"
                  :class="isDark ? 'text-zinc-600' : 'text-gray-500'">Ajouter</div>
              </div>
            </div>
          </button>
        </div>

        <!-- Empty state -->
        <div v-else class="text-center py-12">
          <i class="fas fa-box-open text-4xl mb-4 transition-colors duration-200"
            :class="isDark ? 'text-zinc-700' : 'text-gray-300'"></i>
          <p class="text-sm transition-colors duration-200"
            :class="isDark ? 'text-zinc-500' : 'text-gray-500'">Aucun service disponible</p>
        </div>
      </div>
    </div>

    <!-- Modale TPE -->
    <div v-if="showTpeModal" class="fixed inset-0 bg-black/80 flex items-center justify-center z-50 backdrop-blur-sm" @click.self="closeTpeModal">
      <div class="border rounded-2xl p-8 max-w-md w-full mx-4 space-y-6 transition-colors duration-200"
        :class="isDark
          ? 'bg-zinc-900 border-zinc-800'
          : 'bg-white border-gray-200'">
        <div class="text-center space-y-2">
          <div class="w-16 h-16 bg-blue-950/40 border border-blue-900/40 rounded-full mx-auto flex items-center justify-center">
            <i class="fas fa-credit-card text-blue-400 text-2xl"></i>
          </div>
          <h2 class="text-xl font-medium transition-colors duration-200"
            :class="isDark ? 'text-white' : 'text-gray-900'">Paiement par Carte Bancaire</h2>
          <p class="text-xs transition-colors duration-200"
            :class="isDark ? 'text-zinc-500' : 'text-gray-500'">En attente du paiement sur le terminal</p>
        </div>

        <!-- Montant -->
        <div class="border rounded-xl p-6 text-center space-y-2 transition-colors duration-200"
          :class="isDark
            ? 'bg-zinc-950/60 border-zinc-800'
            : 'bg-gray-50 border-gray-200'">
          <div class="text-xs uppercase tracking-wider transition-colors duration-200"
            :class="isDark ? 'text-zinc-500' : 'text-gray-500'">Montant</div>
          <div class="font-mono font-bold text-4xl transition-colors duration-200"
            :class="isDark ? 'text-white' : 'text-gray-900'">{{ finalNetPrice }} €</div>
        </div>

        <!-- Animation de chargement -->
        <div class="flex justify-center">
          <div class="relative">
            <div class="animate-spin rounded-full h-16 w-16 border-b-2 border-blue-400"></div>
            <div class="absolute inset-0 flex items-center justify-center">
              <i class="fas fa-credit-card text-blue-400 text-xl"></i>
            </div>
          </div>
        </div>

        <div class="bg-blue-950/20 border border-blue-900/40 rounded-xl p-4">
          <p class="text-xs text-blue-400 text-center">
            <i class="fas fa-info-circle mr-1.5"></i>
            Veuillez suivre les instructions sur le terminal de paiement
          </p>
        </div>

        <div class="space-y-2">
          <button @click="confirmTpePayment" class="w-full bg-emerald-600 hover:bg-emerald-500 text-white py-3 rounded-xl text-xs font-semibold uppercase tracking-wider transition-colors">
            <i class="fas fa-check mr-2"></i>
            Confirmer le paiement
          </button>
          <button @click="closeTpeModal" class="w-full py-3 rounded-xl text-xs font-medium uppercase tracking-wider transition-colors"
            :class="isDark
              ? 'bg-zinc-800 hover:bg-zinc-700 text-zinc-300'
              : 'bg-gray-200 hover:bg-gray-300 text-gray-700'">
            <i class="fas fa-times mr-2"></i>
            Annuler
          </button>
        </div>
      </div>
    </div>

  </div>
</template>

<script setup>
import { ref, reactive, computed, onMounted, watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { toast } from 'vue3-toastify'
import { useTheme } from '@/composables/useTheme'
import api from '@/api'

// === Thème ===
const { isDark } = useTheme()

const route = useRoute()
const router = useRouter()

// Real clients from backend
const mockClients = ref([])

// Payment modals state
const showQrCodeModal = ref(false)
const showTpeModal = ref(false)
const showServiceModal = ref(false)
const qrCodeData = ref(null)
const stripeSessionId = ref(null)
const paymentStatus = ref('pending') // 'pending', 'checking', 'success', 'failed'

// Services state
const availableServices = ref([])
const serviceSearchQuery = ref('')

// Fetch clients from backend
const fetchClients = async () => {
  try {
    const response = await api.clients.getAllClients()
    mockClients.value = (response.data || []).map(client => ({
      id: client._id,
      nom: `${client.prenom} ${client.nom}`,
      email: client.email || null,
      acompteValide: client.acompte || 0
    }))
  } catch (error) {
    console.error('Erreur lors du chargement des clients', error)
    toast.error('Erreur lors du chargement des clients')
  }
}

// Fetch promotions from backend
const fetchPromotions = async () => {
  try {
    const response = await api.promotions.getAllPromotions()
    const promos = response.data.data || []

    // Filtrer uniquement les promotions actives et mapper au format attendu
    availablePromotions.value = promos
      .filter(promo => promo.actif)
      .map(promo => ({
        id: promo._id,
        nom: promo.nom,
        type: promo.type === 'percentage' ? 'pourcentage' : 'fixe',
        valeur: promo.valeur
      }))

    console.log('✅ Promotions chargées:', availablePromotions.value.length)
  } catch (error) {
    console.error('Erreur lors du chargement des promotions', error)
    toast.error('Erreur lors du chargement des promotions')
  }
}

// Pré-remplir le panier depuis un rendez-vous
const prefillFromAppointment = async () => {
  if (!route.query.appointmentId) return

  console.log('💳 Pré-remplissage de la caisse depuis rendez-vous:', route.query.appointmentId)
  console.log('📋 Query params reçus:', route.query)

  transaction.appointmentId = route.query.appointmentId

  // Récupérer les détails complets du rendez-vous depuis l'API
  try {
    const response = await api.appointments.getAppointmentById(route.query.appointmentId)
    const appointment = response.data

    console.log('📅 Détails du rendez-vous récupérés:', appointment)

    // Récupérer le montant déjà payé en ligne
    if (appointment.paymentAmount && appointment.paymentAmount > 0) {
      appointmentPaymentAmount.value = appointment.paymentAmount
      appointmentIsPaidCompletely.value = appointment.isPaid || false
      console.log(`💰 Montant déjà payé en ligne: ${appointment.paymentAmount}€ (Paiement complet: ${appointment.isPaid})`)

      const messageType = appointment.isPaid ? 'Paiement intégral' : 'Acompte'
      toast.info(`${messageType} de ${appointment.paymentAmount}€ déjà payé en ligne`, {
        position: 'top-right',
        autoClose: 3000
      })
    }
  } catch (error) {
    console.error('Erreur lors de la récupération du rendez-vous:', error)
  }

  // Parser les services
  if (route.query.services) {
    try {
      const services = JSON.parse(route.query.services)

      // Ajouter chaque service au panier
      services.forEach(service => {
        transaction.cart.push({
          nom: service.nom,
          type: 'prestation',
          prix: service.prix || 0,
          qte: 1
        })
      })

      console.log('✅ Services ajoutés au panier:', transaction.cart)
    } catch (error) {
      console.error('Erreur lors du parsing des services:', error)
    }
  }

  // Pré-sélectionner le client (les clients sont déjà chargés à ce stade)
  if (route.query.clientId) {
    // Forcer en string pour correspondre avec les options du select
    const clientIdToSelect = String(route.query.clientId);

    console.log('🔍 Tentative de sélection du client ID:', clientIdToSelect)
    console.log('📋 Clients disponibles:', mockClients.value.map(c => ({ id: c.id, nom: c.nom })))

    // Vérifier que le client existe dans la liste
    const clientExists = mockClients.value.find(c => String(c.id) === clientIdToSelect);

    if (clientExists) {
      transaction.clientId = clientIdToSelect;
      console.log('✅ Client pré-sélectionné:', clientExists.nom)
    } else {
      console.warn('⚠️ Client non trouvé dans la liste')
      console.warn('⚠️ ID recherché:', clientIdToSelect)
      console.warn('⚠️ IDs disponibles:', mockClients.value.map(c => String(c.id)))
    }
  } else if (route.query.clientName) {
    // Fallback : chercher par nom si pas d'ID
    const matchingClient = mockClients.value.find(c =>
      c.nom.toLowerCase().includes(route.query.clientName.toLowerCase())
    )

    if (matchingClient) {
      transaction.clientId = String(matchingClient.id)
      console.log('✅ Client pré-sélectionné par nom:', matchingClient.nom)
    } else {
      console.warn('⚠️ Aucun client trouvé pour le nom:', route.query.clientName)
    }
  }

  // Toast de confirmation
  if (route.query.clientName) {
    toast.success(`Paiement pré-rempli pour ${route.query.clientName}`, {
      position: 'top-right',
      autoClose: 3000
    })
  }
}

// Load clients on mount
onMounted(async () => {
  // 1. Charger les données critiques
  await Promise.all([fetchClients(), fetchPromotions()]);

  // 2. Maintenant que les listes sont remplies, on peut pré-remplir
  await prefillFromAppointment();
})

// Payment structure configuration options
const paymentMethods = ref([
  { id: "CB", nom: "Carte Bancaire", icon: "fas fa-credit-card", disabled: true, message: "À venir plus tard" },
  { id: "CASH", nom: "Espèces / Caisse", icon: "fas fa-money-bill-wave" },
  { id: "CHQ", nom: "Chèque", icon: "fas fa-money-check" },
  { id: "LYF", nom: "Lien Sans Contact", icon: "fas fa-qrcode" }
])

// Promotions disponibles (chargées depuis le backend)
const availablePromotions = ref([])

// Montant déjà payé en ligne pour ce rendez-vous
const appointmentPaymentAmount = ref(0)
const appointmentIsPaidCompletely = ref(false)

// Main state data model for the open cash ticket instance
const transaction = reactive({
  clientId: "",
  cart: [],
  paymentMethod: "CASH",  // Défaut: Espèces (CB est désactivé)
  appointmentId: null,
  // Système de promotions
  selectedPromoId: "",
  discountType: "pourcentage", // 'pourcentage' ou 'fixe'
  discountValue: 0 // Valeur de la réduction
})

// Client data computing loader
const selectedClient = computed(() => {
  return mockClients.value.find(c => c.id === transaction.clientId) || null
})

// Filtered services based on search
const filteredServices = computed(() => {
  if (!serviceSearchQuery.value) {
    return availableServices.value
  }

  const query = serviceSearchQuery.value.toLowerCase()
  return availableServices.value.filter(service =>
    service.nom.toLowerCase().includes(query) ||
    (service.description && service.description.toLowerCase().includes(query)) ||
    (service.categorie && service.categorie.toLowerCase().includes(query))
  )
})

// Advanced computing subtotal prices variables
const subtotalPrice = computed(() => {
  return transaction.cart.reduce((acc, curr) => acc + (curr.prix * curr.qte), 0)
})

// Calculer le montant de la réduction
const discountAmount = computed(() => {
  const value = parseFloat(transaction.discountValue) || 0;
  const subtotal = subtotalPrice.value || 0;

  if (transaction.discountType === 'pourcentage') {
    // Calcul sécurisé du pourcentage
    return (subtotal * Math.min(value, 100)) / 100;
  } else {
    // Calcul sécurisé du montant fixe
    return Math.min(value, subtotal);
  }
});

const finalNetPrice = computed(() => {
  let basePrice = subtotalPrice.value;

  // Soustraire la réduction (le computed discountAmount est déjà calculé)
  basePrice -= discountAmount.value;

  // Déduire le montant déjà payé en ligne
  if (appointmentPaymentAmount.value > 0) {
    basePrice -= appointmentPaymentAmount.value;
  }

  // Retourner un nombre positif ou 0
  return Math.max(0, basePrice).toFixed(2);
});

const taxPrice = computed(() => {
  return (finalNetPrice.value * 0.20).toFixed(2) // 20% internal VAT system calculation
})

// Flag pour éviter les boucles lors de l'application d'une promo
let isApplyingPromo = false

// Watchers pour déselectionner la promo pré-créée si l'utilisateur modifie manuellement
watch(() => transaction.discountType, () => {
  if (!isApplyingPromo && transaction.selectedPromoId) {
    console.log('🔄 Type de réduction modifié manuellement, désélection de la promo')
    transaction.selectedPromoId = ""
  }
})

watch(() => transaction.discountValue, () => {
  if (!isApplyingPromo && transaction.selectedPromoId) {
    console.log('🔄 Valeur de réduction modifiée manuellement, désélection de la promo')
    transaction.selectedPromoId = ""
  }
})

// Transaction interaction controls
const setPaymentMethod = (id) => {
  transaction.paymentMethod = id
}

// Appliquer une promotion pré-créée
const applyPromotion = () => {
  if (!transaction.selectedPromoId) {
    // Réinitialiser si aucune promo
    isApplyingPromo = true
    transaction.discountValue = 0
    transaction.discountType = 'pourcentage'
    setTimeout(() => { isApplyingPromo = false }, 0)
    return
  }

  const promo = availablePromotions.value.find(p => String(p.id) === String(transaction.selectedPromoId))

  if (promo) {
    // Bloquer les watchers pendant qu'on applique la promo
    isApplyingPromo = true

    transaction.discountType = promo.type
    transaction.discountValue = promo.valeur

    console.log('✅ Promotion appliquée:', promo.nom, `${promo.valeur}${promo.type === 'pourcentage' ? '%' : '€'}`)

    toast.success(`Promotion "${promo.nom}" appliquée`, {
      position: 'top-right',
      autoClose: 2000
    })

    // Débloquer les watchers après un court délai
    setTimeout(() => { isApplyingPromo = false }, 0)
  } else {
    console.warn('⚠️ Promotion non trouvée:', transaction.selectedPromoId)
    console.warn('⚠️ Promotions disponibles:', availablePromotions.value)
  }
}

const removeItem = (index) => {
  transaction.cart.splice(index, 1)
}

const openItemCatalog = async () => {
  try {
    // Fetch services to add to cart
    const response = await api.services.getAllServices()
    availableServices.value = response.data || []

    if (availableServices.value.length === 0) {
      toast.warning('Aucun service disponible', {
        position: 'top-right',
        autoClose: 3000
      })
      return
    }

    // Open modal to select service
    serviceSearchQuery.value = ''
    showServiceModal.value = true

  } catch (error) {
    console.error('Erreur lors du chargement des services', error)
    toast.error('Erreur lors du chargement des services')
  }
}

// Add selected service to cart
const addServiceToCart = (service) => {
  transaction.cart.push({
    nom: service.nom,
    type: "prestation",
    prix: service.prix || 0,
    qte: 1
  })

  toast.success(`"${service.nom}" ajouté au panier`, {
    position: 'top-right',
    autoClose: 2000
  })

  // Keep modal open in case user wants to add more services
  // closeServiceModal()
}

// Close service modal
const closeServiceModal = () => {
  showServiceModal.value = false
  serviceSearchQuery.value = ''
}

const executeCheckout = async () => {
  if (transaction.cart.length === 0) {
    toast.error('Le panier est vide', {
      position: 'top-right',
      autoClose: 3000
    })
    return
  }

  // Vérifier si le montant est déjà entièrement payé en ligne
  if (appointmentIsPaidCompletely.value && parseFloat(finalNetPrice.value) === 0) {
    toast.info('Ce rendez-vous est déjà entièrement payé en ligne', {
      position: 'top-right',
      autoClose: 4000
    })
    return
  }

  if (!transaction.paymentMethod) {
    toast.error('Veuillez sélectionner un mode de paiement', {
      position: 'top-right',
      autoClose: 3000
    })
    return
  }

  try {
    console.log('💳 Démarrage du checkout...', transaction.paymentMethod)

    // Si paiement par lien sans contact (Stripe)
    if (transaction.paymentMethod === 'LYF') {
      await handleStripePayment()
      return
    }

    // Si paiement par CB (TPE)
    if (transaction.paymentMethod === 'CB') {
      await handleTpePayment()
      return
    }

    // Pour les autres méthodes (CASH, CHQ, OTHER) - enregistrement direct
    await processDirectPayment()

  } catch (error) {
    console.error('Erreur lors de l\'enregistrement de la transaction', error)
    toast.error('Erreur lors de l\'enregistrement')
  }
}

// Gérer le paiement Stripe avec QR Code
const handleStripePayment = async () => {
  try {
    console.log('🔗 Création du lien de paiement Stripe...')

    const payload = {
      clientId: transaction.clientId || null,
      appointmentId: transaction.appointmentId || null,
      cart: transaction.cart,
      montantTotal: subtotalPrice.value,
      montantReduction: discountAmount.value,
      montantFinal: parseFloat(finalNetPrice.value),
      clientEmail: selectedClient.value?.email || null,
      clientName: selectedClient.value?.nom || 'Client'
    }

    const response = await api.transactions.createPaymentLink(payload)

    console.log('✅ Lien de paiement créé:', response.data)

    // Afficher la modale avec le QR Code
    qrCodeData.value = response.data.qrCode
    stripeSessionId.value = response.data.sessionId
    showQrCodeModal.value = true
    paymentStatus.value = 'pending'

    // Démarrer la vérification périodique du statut du paiement
    startPaymentStatusCheck()

    toast.success('QR Code généré !', {
      position: 'top-right',
      autoClose: 2000
    })

  } catch (error) {
    console.error('Erreur lors de la création du lien de paiement:', error)
    toast.error('Erreur lors de la création du QR Code')
  }
}

// Vérifier périodiquement si le paiement Stripe a été effectué
let paymentCheckInterval = null
const startPaymentStatusCheck = () => {
  // Vérifier toutes les 3 secondes
  paymentCheckInterval = setInterval(async () => {
    try {
      paymentStatus.value = 'checking'
      const response = await api.transactions.verifyStripePayment(stripeSessionId.value)

      if (response.data.success) {
        clearInterval(paymentCheckInterval)
        paymentStatus.value = 'success'

        toast.success('✅ Paiement confirmé !', {
          position: 'top-right',
          autoClose: 3000
        })

        // Fermer la modale et rediriger
        closeQrCodeModal()
        resetCart()
        setTimeout(() => {
          router.push('/finance')
        }, 1500)
      }
    } catch (error) {
      // Le paiement n'est pas encore effectué, continuer à vérifier
      paymentStatus.value = 'pending'
    }
  }, 3000)
}

// Gérer le paiement par TPE
const handleTpePayment = async () => {
  try {
    console.log('💳 Initiation du paiement TPE...')

    // Afficher la modale TPE
    showTpeModal.value = true

    const payload = {
      montantFinal: parseFloat(finalNetPrice.value),
      tpeProvider: 'generic' // À adapter selon le TPE utilisé
    }

    const response = await api.transactions.initiateTpePayment(payload)

    console.log('✅ Paiement TPE initié:', response.data)

  } catch (error) {
    console.error('Erreur lors de l\'initiation du paiement TPE:', error)
    toast.error('Erreur lors de l\'initiation du paiement TPE')
    showTpeModal.value = false
  }
}

// Confirmer le paiement TPE (appelé manuellement par l'utilisateur)
const confirmTpePayment = async () => {
  try {
    console.log('✅ Confirmation manuelle du paiement TPE')

    // Enregistrer la transaction
    await processDirectPayment()

    // Fermer la modale
    closeTpeModal()

  } catch (error) {
    console.error('Erreur lors de la confirmation du paiement TPE:', error)
    toast.error('Erreur lors de la confirmation')
  }
}

// Traiter les paiements directs (CASH, CHQ, OTHER, ou après confirmation TPE)
const processDirectPayment = async () => {
  const payload = {
    clientId: transaction.clientId || null,
    appointmentId: transaction.appointmentId || null,
    paymentMethod: transaction.paymentMethod,
    cart: transaction.cart,
    montantTotal: subtotalPrice.value,
    montantReduction: discountAmount.value,
    montantAcompte: appointmentPaymentAmount.value || 0,
    montantFinal: parseFloat(finalNetPrice.value),
    discountType: transaction.discountType,
    discountValue: transaction.discountValue,
    promoCode: transaction.selectedPromoId ? availablePromotions.value.find(p => String(p.id) === String(transaction.selectedPromoId))?.nom : null,
    notes: null
  }

  console.log('📤 Payload envoyé:', payload)

  const response = await api.transactions.checkout(payload)

  console.log('✅ Réponse du serveur:', response.data)

  toast.success('✅ Paiement enregistré avec succès !', {
    position: 'top-right',
    autoClose: 3000
  })

  resetCart()

  // Rediriger vers le livre des transactions
  setTimeout(() => {
    router.push('/finance')
  }, 1500)
}

// Réinitialiser le panier
const resetCart = () => {
  transaction.cart = []
  transaction.clientId = ""
  transaction.appointmentId = null
  transaction.selectedPromoId = ""
  transaction.discountValue = 0
  transaction.paymentMethod = "CASH"  // Défaut: Espèces (CB est désactivé)
}

// Fermer la modale QR Code
const closeQrCodeModal = () => {
  if (paymentCheckInterval) {
    clearInterval(paymentCheckInterval)
    paymentCheckInterval = null
  }
  showQrCodeModal.value = false
  qrCodeData.value = null
  stripeSessionId.value = null
  paymentStatus.value = 'pending'
}

// Fermer la modale TPE
const closeTpeModal = () => {
  showTpeModal.value = false
}

// Fermer la modale de sélection de service (déjà définie plus haut)
// Pas besoin de redéfinir

const printReceiptOnly = () => {
  toast.info('Impression du reçu...', { position: 'top-right' })
}
</script>

<style scoped>
/* Technical system layout input scroll reset controls */
input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
input[type="number"] {
  -moz-appearance: textfield;
}

.no-scrollbar::-webkit-scrollbar {
  display: none;
}
.no-scrollbar {
  -ms-overflow-style: none;
  scrollbar-width: none;
}
</style>